<template>
  <div class="pr-2">
    <template
      v-if="db_line_items && db_line_items.length && db_line_items.length > 0"
    >
      <div
        class="d-flex grey lighten-4 px-2"
        style="border-bottom: solid 1px #e4e3e3 !important"
      >
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 5%"
        >
          #
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 5%"
        >
          Line #
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 10%"
        >
          Item #
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 10%"
        >
          IMPA #
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-left"
          style="width: 50%"
        >
          Product
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 10%"
        >
          Unit Cost
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 10%"
        >
          Quantity
        </div>
      </div>
      <div
        v-for="(row, index) in db_line_items"
        class="line-item-drag"
        :key="`line-item-drag-${index}`"
        :class="{ 'line-item-v2-alternate-row': index % 2 ? true : false }"
      >
        <div :id="`line-item-drag-${index}`" class="d-flex py-1 px-2">
          <div class="font-weight-600 text-center" style="width: 5%">
            <template>
              <div class="font-weight-600 mt-0">{{ index + 1 }}.</div>
            </template>
          </div>
          <div class="font-weight-600 text-center" style="width: 5%">
            <template>
              <div class="font-weight-600 mt-0">
                {{ row.line_number }}
              </div>
            </template>
          </div>
          <div class="font-weight-600 text-center" style="width: 10%">
            <template>
              <div class="font-weight-600 mt-0">
                {{ row.item_number }}
              </div>
            </template>
          </div>
          <div class="font-weight-600 text-center" style="width: 10%">
            <template>
              <div class="font-weight-600 mt-0">
                {{ row.impa_number }}
              </div>
            </template>
          </div>
          <div class="font-weight-600 text-left" style="width: 50%">
            <template>
              <div class="font-weight-600 mt-0">
                {{ row.product_name }}
              </div>
            </template>
          </div>
          <div class="font-weight-600 text-center" style="width: 10%">
            <template>
              <div class="font-weight-600 mt-0">
                {{ row.unit_price }}
              </div>
            </template>
          </div>
          <div class="font-weight-600 text-center" style="width: 10%">
            <template>
              <div class="font-weight-600 mt-0">
                {{ row.quantity }} {{ row.unit }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex align-center justify-center mt-2">
        <img
          :src="$assetURL('media/error/empty.png')"
          class="row-not-found-image"
        />
        Uhh... There are no imported line items at the moment.
      </div>
    </template>
  </div>
</template>

<script>
import { GET } from "@/core/services/store/request.module";
export default {
  name: "imported-visit-line-item",
  props: {
    quotationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      db_line_items: [],
      loading: false,
    };
  },
  methods: {
    get_line_items() {
      this.loading = true;
      this.$store
        .dispatch(GET, {
          url: `quotation/${this.quotationId}/imported-line-items`,
        })
        .then(({ data }) => {
          this.db_line_items = data;
          this.$emit("imported-line-item", this.db_line_items.length);
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    get_col_style() {
      let width = 55;
      return { width: `${width}%` };
    },
  },
  mounted() {
    this.get_line_items();
  },
};
</script>
